import theme from '../../../styles/theme.mjs';
import { StyledIconButton } from '../../Basic/IconButton/IconButton.styles.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import styled from 'styled-components';

const StyledVideoControlIconButtonContainer = styled(FlexContainer) `
  color: ${props => props.theme.colors.mist};
  font-size: ${props => props.theme.typography.text.micro.fontSize};
  justify-self: center;
  align-self: center;
  background-color: ${props => props.variant === 'primary' ? props.theme.colors.skyBlue : `${theme.colors.slate}99`};
  border-radius: 0.25rem;
  width: ${props => (props.children ? 'max-content' : '2.5rem')};
  padding: ${props => (props.children ? '0 1rem' : '0')};

  ${StyledIconButton} {
    height: 2.5rem;

    span {
      display: flex;
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }

    path {
      transition-property: fill;
      transition-duration: ${props => props.theme.animation.duration.quick1};
      transition-timing-function: ${props => props.theme.animation.easing.expressive.standard};
      fill: ${props => props.variant === 'primary' ? props.theme.colors.mist : props.theme.colors.white};
    }

    @media (pointer: fine) {
      :hover {
        path {
          fill: ${props => props.theme.colors.white};
        }
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    width: ${props => (props.children ? 'max-content' : '4rem')};
    padding: ${props => (props.children ? '0 1rem' : '0')};

    ${StyledIconButton} {
      height: 4rem;

      svg {
        width: 2rem;
        height: 2rem;
      }
    }
  }
`;

export { StyledVideoControlIconButtonContainer };
//# sourceMappingURL=VideoControlIconButton.styles.mjs.map
